<template>
	<li>
		<router-link
			class="the-sidebar-item"
			:to="data.link"
			v-if="data.link"
		>
			<span class="the-sidebar-item-icon-wrap">
				<img class="the-sidebar-item-icon" :src="getPathImage('assets/menu-icons/', data.icon)" :alt="data.icon">
				<!-- <i
					class="the-sidebar-item-icon"
					:class="`fz-20 fa-solid ${data.icon}`"
					v-if="data.icon"
				></i> -->
			</span>
			<span class="the-sidebar-item-label">
				{{ data.label }}
			</span>
		</router-link>
	</li>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
		},
	},
	data() {
		return {
			isActive: false,
		};
	},
	
};
</script>

<style lang="scss" scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css");

.the-sidebar-item {
	height: 52px;
	box-sizing: border-box;
	padding: 12px 24px 12px 24px;
	display: flex;
	place-items: center;
	color: #000;
	font-weight: 500;
	position: relative;
	transition: all 0.2s;

	&.the-sidebar-sub-item {
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-ms-transition: all 0.5s;
		transition: all 0.5s;
	}

	&.has-subitem::before {
		content: "";
		position: absolute;
		top: auto;
		bottom: auto;
		right: 16px;
		width: 24px;
		height: 24px;

		background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjYyODcgMTYuMTU3NkMxMS44NDcxIDE2LjM3NiAxMi4xNTI5IDE2LjM3NiAxMi4zNzEzIDE2LjE1NzZMMTguODM2MiA5LjczNjM1QzE5LjA1NDYgOS41NjE2MiAxOS4wNTQ2IDkuMjEyMTcgMTguODM2MiA4Ljk5Mzc2TDE3Ljk2MjYgOC4xNjM4MUMxNy43ODc4IDcuOTQ1NCAxNy40Mzg0IDcuOTQ1NCAxNy4yMiA4LjE2MzgxTDEyLjAyMTggMTMuMzE4M0w2Ljc4MDAzIDguMTYzODFDNi41NjE2MiA3Ljk0NTQgNi4yNTU4NSA3Ljk0NTQgNi4wMzc0NCA4LjE2MzgxTDUuMTYzODEgOC45OTM3NkM0Ljk0NTQgOS4yMTIxNyA0Ljk0NTQgOS41NjE2MiA1LjE2MzgxIDkuNzM2MzVMMTEuNjI4NyAxNi4xNTc2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==")
			no-repeat center center;
	}

	&.has-subitem.mn_active {
		background: rgba(62, 105, 246, 0.06);
		color: #3e69f6;

		&::before {
			transform: rotate(180deg);
			transition: ease-in-out 0.3s;
		}
	}

	&:hover {
		background-color: #f6f6f6;
		color: #3e69f6;
		cursor: pointer;
		z-index: 99;
	}

	&.item-active {
		color: #3e69f6;
		background: rgba(62, 105, 246, 0.05);

		// &::before {
		//   background: url();
		// }
	}

	&.current {
		color: #3e69f6;
		background: #f5f8ff;
	}

	&-icon {
		width: 28px;
		height: 28px;
		display: flex;
		place-content: center;
		place-items: center;
	}

	&-label {
		margin-left: 12px;
	}

	&-subitem {
		height: 44px;
		box-sizing: border-box;
		padding: 16px 24px 16px 64px;
		display: flex;
		place-items: center;
		color: #000;
		font-weight: 500;
		&:hover {
			background: #f6f6f6;
			color: #3e69f6;
		}
		&.current {
			color: #3e69f6;
			background: #f5f8ff;
		}
	}
}
</style>
